import * as React from "react";
import { SVGProps } from "react";

const Algorand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113 113" {...props}>
    <path d="M19.6 113.4 36 85l16.4-28.3 16.3-28.4 2.7-4.5 1.2 4.5 5 18.7-5.6 9.7L55.6 85l-16.3 28.4h19.6L75.3 85l8.5-14.7 4 14.7 7.6 28.4H113L105.4 85l-7.6-28.3-2-7.3L108 28.3H90.2l-.6-2.1L83.4 3l-.8-3H65.5l-.4.6-16 27.7-16.4 28.4L16.4 85 0 113.4h19.6z" />
  </svg>
);

export default Algorand;
